import { FC, useEffect } from "react";

import { ThemeProvider } from "@mui/material";
import Box from "@mui/material/Box";

import { ThemedOrganizationLogoAndNameBlock } from "../../FormV2/sharedComponents/ThemedOrganizationLogoAndNameBlock";
import { NewsletterFormEmbeddedPageLayout } from "../sharedComponents/NewsletterFormEmbeddedPageLayout";
import { NewsletterFormPageLayout } from "../sharedComponents/NewsletterFormPageLayout";
import { NewsletterFormSignUp } from "../sharedComponents/NewsletterFormSignUp";

import { useDynamicFormV2Theme } from "@/components/forms-design-system/Tokens/dynamicFormV2Theme";
import { AmplitudeEvents } from "@/constants/amplitude";
import { useAmplitude } from "@/hooks/amplitude/useAmplitude";
import { NewsletterFormFrontendPageOutput } from "@/types/trpc";

export const NewsletterFormContainer: FC<{
  newsletterForm: NewsletterFormFrontendPageOutput;
  isEmbedded?: boolean;
}> = ({ newsletterForm, isEmbedded }) => {
  const { logAmplitudeEvent } = useAmplitude();

  useEffect(() => {
    logAmplitudeEvent(AmplitudeEvents.SignupFormVisited, {
      organizationId: newsletterForm.organization.id,
      formId: newsletterForm.id,
      formPath: newsletterForm.path,
      isEmbedded,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const themeV2 = useDynamicFormV2Theme(newsletterForm.buttonColor, "light");

  if (isEmbedded) {
    return (
      <NewsletterFormEmbeddedPageLayout>
        <NewsletterFormSignUp newsletterForm={newsletterForm} isEmbedded />
      </NewsletterFormEmbeddedPageLayout>
    );
  }

  return (
    <NewsletterFormPageLayout
      backgroundColor={newsletterForm.buttonColor}
      slots={{
        organizationBanner: (
          <Box>
            <ThemeProvider theme={themeV2}>
              <ThemedOrganizationLogoAndNameBlock
                name={newsletterForm.organization.name}
                logoSrc={newsletterForm.organization.logoUrl ?? undefined}
              />
            </ThemeProvider>
          </Box>
        ),
        form: (
          <ThemeProvider theme={themeV2}>
            <NewsletterFormSignUp newsletterForm={newsletterForm} />
          </ThemeProvider>
        ),
      }}
    />
  );
};
